import styled from "styled-components"
import { device } from "utils/breakpoints.js"

export const TextInputContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  position: relative;
  flex-direction: column;

  @media ${device.desktop} {
    margin-bottom: 30px;
  }

  svg.error {
    @media ${device.tablet} {
    }
  }

  label {
    pointer-events: none;
  }
`

export const Input = styled.input`
  display: block;
  /* outline: none; */
  width: 100%;
  border-radius: 2px;
  padding: ${props =>
    props.floatingLabel ? "23px 15px 13px 15px" : "5px 15px 5px 15px"};
  height: 60px;
  border: 1px solid #d2d4e0;
  font-size: 16px;
  color: #4c4d58;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.1);

  :focus {
    border: 1px solid #4c4d58;
  }

  border: ${props => props.showError && "1px solid #F7376A"};

  @media ${device.desktop} {
    height: 90px;
    padding: ${props =>
      props.floatingLabel ? "21px 20px 3px 30px" : " 5px 20px 5px 20px"};
    font-size: 20px;
  }
`

export const Area = styled.textarea`
  display: block;
  /* outline: none; */
  width: 100%;
  border-radius: 2px;
  padding: ${props =>
    props.floatingLabel ? "23px 15px 3px 15px" : "5px 15px 5px 15px"};
  height: 120px;
  border: 1px solid #d2d4e0;
  ${props => (props.showError ? "#D94E4E" : props.theme.violet)};
  resize: none;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;

  :focus {
    border: 1px solid #4c4d58;
  }
  border: ${props => props.showError && "1px solid #F7376A"};

  @media ${device.desktop} {
    height: 180px;
    padding: ${props =>
      props.floatingLabel ? "38px 20px 20px 30px" : " 5px 20px 5px 20px"};
    font-size: 20px;
  }
`
